export default __webpack_public_path__ + "static/media/location.ffa2fd29.svg";